<!--
 * @Author: ShiWeiShan
 * @Date: 2020-12-22 14:05:51
 * @LastEditTime: 2020-12-28 10:05:16
 * @LastEditors: ShiWeiShan
 * @Description: 代缴费记录列表
 * @FilePath: \fs-js-pcweb-user\src\components\recordListTable\billList.vue
-->
<template>
  <div class="bill-list">
    <!-- 缴费列表 -->
    <el-table
      ref="Superplanlistref"
      :data="tableData"
      highlight-current-row
      stripe
      height="500"
      border
      size="mini"
    >
      <el-table-column
        align="center"
        show-overflow-tooltip
        label="#"
        type="index"
        width="50"
      ></el-table-column>
      <el-table-column
        prop="s_time"
        align="center"
        show-overflow-tooltip
        label="开始月份"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="e_time"
        align="center"
        show-overflow-tooltip
        label="结束月份"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="raise_sum"
        align="center"
        show-overflow-tooltip
        label="加价金额(元)"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="price"
        align="center"
        show-overflow-tooltip
        label="供水单价(元)"
        width="120"
      ></el-table-column>
      <el-table-column
        prop="odesc"
        show-overflow-tooltip
        label="备注"
      ></el-table-column>
      <el-table-column label="操作" fixed="right" width="200" align="center">
        <template slot-scope="scope">
          <el-button
            size="small"
            class="btn-marleft"
            type="primary"
            plain
            @click.native.prevent="handleTableToolClik(scope.row,'operation')"
          >处理</el-button>
          <el-button
            size="small"
            class="btn-marleft"
            type="primary"
            plain
            @click.native.prevent="handleTableToolClik(scope.row,'details')"
          >详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <hd-loading type="tip" v-if="tipLoading"></hd-loading>
    <common-dialog
      append-to-body
      v-if="dialogVisible"
      :title="dialogOptions.title"
      :width="dialogOptions.width"
      :height="dialogOptions.height"
      :visible.sync="dialogVisible"
      cover
    >
      <review-flow-chart v-if="dialogName === 'operation'" :billData="currentRowData" @successThen="successThen" @cancel="dialogVisible=false"></review-flow-chart>
      <review-detail v-else :billData="currentRowData" @successThen="successThen" @cancel="dialogVisible=false"></review-detail>
    </common-dialog>
  </div>
</template>

<script>
import {
  A_WBDT_QueryBillList // 查询收费记录数据
} from '@/assets/js/axiosPresets'
import reviewFlowChart from "@/components/Reviewflowchart/index" // 缴费流程图
import reviewDetail from "@/components/Reviewflowchart/detail" // 详情
export default {
  components: {
    reviewFlowChart,
    reviewDetail
  },
  data () {
    return {
      tipLoading: false, // loading
      tableData: [], // 列表数据
      dialogOptions: {
        title: '',
        width: '600px',
        height: ''
      }, // 弹框样式
      dialogVisible: false, // 弹窗是否显示
      currentRowData: {}, // 当前活跃的表格行
      dialogName: ''
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  methods: {
    async initData () {
      this.getTableData()
    },
    // 数据：查询收费状态
    async getTableData () {
      const data = {
        audit_status: "",
        charge_status: "1",
        sort_field: "",
        sort_order: "",
        user_id: this.userInfo.oid
      }
      this.tipLoading = true
      const wid = await A_WBDT_QueryBillList(data)
      this.tipLoading = false
      console.log(wid)
      if (wid.data.Content) {
        wid.data.Content.forEach((e, index) => {
          e.user_name = this.userInfo.name
          e.user_code = this.userInfo.code
          e.s_time = new Date(e.s_date).format('yyyy-MM')
          e.e_time = new Date(e.e_date).format('yyyy-MM')
        })
        this.tableData = wid.data.Content
      }
    },
    handleTableToolClik (row, type) {
      this.currentRowData = row || {}
      this.dialogName = type
      switch (type) {
        case 'operation':
          this.dialogOptions = {
            title: '代缴费记录处理流程图',
            width: '800px',
            height: ''
          }
          break
        case 'details':
          this.dialogOptions = {
            title: '代缴费记录详情',
            width: '800px',
            height: ''
          }
          break
      }
      this.dialogVisible = true
    },
    successThen () {
      setTimeout(() => {
        this.dialogVisible = false
      }, 0)
      this.getTableData()
    }
  },
  mounted () {
    this.initData()
  }
}
</script>

<style lang="scss" scoped>
.bill-list{
  position: relative;
}
</style>